import { CSSObject } from '@emotion/core';
import { keyframes } from '@emotion/react';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const space0 = token('space.0', '0px');
const space50 = token('space.050', '4px');
const space150 = token('space.150', '12px');
const space200 = token('space.200', '16px');
const space300 = token('space.300', '24px');
const space400 = token('space.400', '32px');

const svgStyling = {
  display: 'flex',
  svg: {
    marginLeft: '1px',
    marginRight: '1px',
    padding: '1px',
  },
  height: space300,
  width: space300,
};

export const SvgContainer = styled.span(svgStyling);

const spin = keyframes({
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(1080deg)',
  },
});

/* stylelint-disable a11y/media-prefers-reduced-motion */
export const SpinningSvgContainer = styled.span({
  ...svgStyling,
  svg: {
    ...svgStyling.svg,
    animation: `fadein 0.25s ease-in, ${spin} 2.5s infinite ease-in-out`,
  },
});

const skeletonItemOverrideBaseCss = (): CSSObject => ({
  ['&::after']: {
    height: space150,
  },
});

export const headingSkeletonOverrideCss = (): CSSObject => ({
  ...skeletonItemOverrideBaseCss(),
  paddingLeft: space50,
  paddingRight: space150,
});

export const mergeCheckItemSkeletonOverrideCss = (): CSSObject => ({
  ...skeletonItemOverrideBaseCss(),
  height: space400,
  minHeight: undefined,
  padding: space0,
  paddingRight: space200,
});

export const PopupCheckMessage = styled.span({});

export const PopupCheckUpdatedLabel = styled.span({
  color: token('color.text.subtlest', colors.N200),
});

export const PopupCheckTypeLabel = styled.div({
  fontSize: '11px',
  fontWeight: 400,
  color: token('color.text.subtlest', colors.N200),
});
